<script setup>
import {Menu, MenuButton} from '@headlessui/vue';
import {useBaseStore} from '@/stores/BaseStore';

const store = useBaseStore();

const defaultAvatar = process.env.BASE_PATH + '/avatar.png';
</script>

<template>
    <Menu as="div" class="flex-shrink-0 relative ml-4">
        <div>
            <MenuButton class="flex items-center bg-white rounded-full flex">
                <div class="ml-3">
                    <p class="text-sm font-medium text-gray-700 group-hover:text-gray-900 pr-2">
                        {{ $tt('user_panel__hi') }} {{ store.currentUser.first_name }}
                    </p>
                </div>
                <div>
                    <img v-if="store.currentUser.image" class="h-8 w-8 rounded-full" :src="store.currentUser.image"
                         :title="store.currentUser.first_name + ' ' + store.currentUser.last_name"/>
                    <img v-else class="h-8 w-8 rounded-full" :src="defaultAvatar"
                         :title="store.currentUser.first_name + ' ' + store.currentUser.last_name"/>
                </div>
            </MenuButton>
        </div>
    </Menu>
</template>

